
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/tree-view/simple-tree-view",
      function () {
        return require("private-next-pages/x/api/tree-view/simple-tree-view.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/tree-view/simple-tree-view"])
      });
    }
  